var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"title":_vm.chartTitle}},[_c('div',{staticClass:"mt-5"},[_c('chartjs-component-line-chart',{attrs:{"height":250,"chart-data":_vm.chartData,"options":_vm.options}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }